import React, { useState } from "react";
import { Button, Container, Center } from "@chakra-ui/react";


import { DocumentList } from "../Documents/components/listDocument";

export default function Document() {

    return (
        <Container maxW="xxl" mt={100}>
            <DocumentList />
        </Container>
    );
}
